import React, { Fragment as div } from 'react';
import styled from "styled-components";
import { useSelector } from 'react-redux';

const Wrapper = styled.div`
    display: flex;
    flex-flow: column nowrap;
    margin-bottom: 1rem;
`

const StyledHeader = ({
    text, 
    ...props
}) => {
    return(
        <Wrapper>
            <h1>{text}</h1>

            <h4>Policenummer: {useSelector(state => state.formReducer.formData.policyNumber)}</h4>
            <h4>Dato for ændring: {useSelector(state => state.formReducer.formData.changeDate)}</h4>
        </Wrapper>
    )
}

export default StyledHeader;